import IconSearch from './icons/icon-search'
import IconCash from './icons/icon-cash'
import IconTenants from './icons/icon-tenants'
import IconPrograms from './icons/icon-programs'
import IconUsers from './icons/icon-users'
import {
  DocumentCurrencyDollarIcon,
  FolderIcon,
  PencilSquareIcon,
  RocketLaunchIcon,
  UserGroupIcon,
  ClipboardDocumentListIcon,
  CheckBadgeIcon,
  ChartBarIcon,
  Squares2X2Icon,
  BoltIcon,
} from '@heroicons/react/24/outline'

export interface NavItem {
  label: string | React.ReactNode
  tooltipLabel?: string
  to: string
  baseRoute?: string
  icon: React.ReactNode
  children?: Array<{
    label: string
    to: string
  }>
  exact?: boolean
}

export const getNavConfig = (
  hasFileExplorer: boolean,
  hasEventHandlingReport: boolean,
  hasSaber: boolean,
  hasConductor: boolean
): NavItem[] => [
    {
      label: (
        <>
          Quick Search <div className="inline-block ml-1 text-xs font-normal">{navigator.userAgent.indexOf('Win') !== -1 ? '⊞K' : '⌘K'}</div>
        </>
      ),
      tooltipLabel: 'Quick Search',
      to: '/',
      exact: true,
      icon: <IconSearch />,
    },
    {
      label: 'Invoices',
      to: '/collections/invoices',
      icon: <DocumentCurrencyDollarIcon className="h-6 w-6" />,
    },
    {
      label: 'Payments',
      to: '/collections/payments',
      icon: <IconCash />,
    },
    ...(hasFileExplorer
      ? [
        {
          label: 'File Explorer',
          to: '/file-explorer',
          icon: <FolderIcon className="h-6 w-6" />,
        },
      ]
      : []),
    {
      label: 'Programs',
      to: '/program/programs',
      icon: <IconPrograms />,
    },
    {
      label: 'Tariffs',
      to: '/admin/tariffs',
      icon: <BoltIcon className="h-6 w-6" />,
    },
    {
      label: 'Tenants',
      to: '/tenant/tenants',
      icon: <IconTenants />,
    },
    {
      label: 'Onboarding',
      to: '/tenant/onboarding',
      icon: <RocketLaunchIcon className="h-6 w-6" />,
    },
    {
      label: 'Notes',
      to: '/notes',
      icon: <PencilSquareIcon className="h-6 w-6" />,
    },
    {
      label: 'Admin Users',
      to: '/users',
      icon: <IconUsers />,
    },
    {
      label: 'Tenant Users',
      to: '/tenant-users',
      icon: <UserGroupIcon className="h-6 w-6" />,
    },
    ...(hasEventHandlingReport
      ? [
        {
          label: 'Event Handling Report',
          to: '/admin/event-handling-report',
          icon: <ClipboardDocumentListIcon className="h-6 w-6" />,
        },
      ]
      : []),
    // Read-only internal dashboard — shown to all admin users (not flag-gated).
    {
      label: 'Go-Live Readiness',
      to: '/admin/go-live-readiness',
      icon: <CheckBadgeIcon className="h-6 w-6" />,
    },
    ...(hasSaber
      ? [
        {
          label: 'SABER',
          to: '/saber',
          icon: <ChartBarIcon className="h-6 w-6" />,
        },
      ]
      : []),
    ...(hasConductor
      ? [
        {
          label: 'Conductor',
          to: '/conductor',
          icon: <Squares2X2Icon className="h-6 w-6" />,
        },
      ]
      : []),
  ]
